import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { AntrepoInService } from '../../../services/AntrepoInService';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import Box from '../../../components/Box';
import { OfferStatusEnum } from '../../../models/common/Enums';
import { GetAntrepoInListPagingAndFilterRequest, initialGetAntrepoInListPagingAndFilterRequest } from '../../../models/request/antrepoIn/GetAntrepoInListPagingAndFilterRequest';
import { GetAntrepoInListPagingAndFilterResponse, GetAntrepoInListPagingAndFilterResponseData, GetAntrepoInListPagingAndFilterResponseItem, initialGetAntrepoInListPagingAndFilterResponseData } from '../../../models/response/antrepoIn/GetAntrepoInListPagingAndFilterResponse';
import AntrepoInListFilters from './Components/AntrepoInListFilters';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { ExportAntrepoInListResponse } from '../../../models/response/antrepoIn/ExportAntrepoInListResponse';
import { DeleteAntrepoInResponse } from '../../../models/response/antrepoIn/DeleteAntrepoInResponse';
import { AntrepoOutService } from '../../../services/AntrepoOutService';
import { GetAntrepoOutListByAntrepoInIdResponse } from '../../../models/response/antrepoOut/GetAntrepoOutListByAntrepoInIdResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, ColumnFilterOption } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadList } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { CompanyService } from '../../../services/CompanyService';
import { ConstantService } from '../../../services/ConstantService';
import { CountryService } from '../../../services/CountryService';
import { GetCompanyListRequest } from '../../../models/request/company/GetCompanyListRequest';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

// Beyanname Durumu seçenekleri: backend'de IsClosed (0 = açık, 1 = kapalı).
const DECLARATION_STATUS_OPTIONS: ColumnFilterOption[] = [
    { value: '0', label: 'Açık Beyanname' },
    { value: '1', label: 'Kapalı Beyanname' },
];

// Açılışta Beyanname Durumu kolon filtresinde "Açık Beyanname" seçili gelir (eski filtre panelindeki varsayılan).
const DEFAULT_COLUMN_FILTERS: ColumnFilterModel[] = [
    { column: 'declarationStatusName', values: ['0'], valueLabels: ['Açık Beyanname'] }
];

// Firma kolonlarının seçenekleri: eski filtre panelindeki gibi iki listenin birleşimi (bir firma ikisinde de olabilir).
const loadCompanies = async (first: GetCompanyListRequest, second: GetCompanyListRequest): Promise<ColumnFilterOption[]> => {
    const lists = await Promise.all([
        loadList(CompanyService.getCompanyList(first), 'companyId', x => x.name),
        loadList(CompanyService.getCompanyList(second), 'companyId', x => x.name),
    ]);

    return lists.flat().filter((x, i, all) => all.findIndex(a => a.value == x.value) == i);
}

const AntrepoInList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Antrepo Modülü > Antrepo Girişi"
    const pageVersion = "3";
    const [data, setData] = useState<GetAntrepoInListPagingAndFilterResponseData>(initialGetAntrepoInListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetAntrepoInListPagingAndFilterRequest>({ ...initialGetAntrepoInListPagingAndFilterRequest, columnFilters: DEFAULT_COLUMN_FILTERS });

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Defter No', name: 'ledgerNo', order: 0, isVisible: true },
            { title: 'Antrepo Beyan No', name: 'antrepoDeclarationNo', order: 0, isVisible: true },
            { title: 'Antrepo Beyan Tarihi', name: 'antrepoDeclarationDateStr', order: 0, isVisible: true },
            { title: 'Beyanname Durumu', name: 'declarationStatusName', order: 0, isVisible: true },
            { title: 'Satış Şekli', name: 'saleTypeName', order: 0, isVisible: true },
            // Araçlardan (alt tablo) birleşik: kayıttaki araçların antrepo giriş tarihleri.
            { title: 'Antrepo Giriş Tarihi', name: 'antrepoEnteranceDatesStr', order: 0, isVisible: true },
            { title: 'Alıcı Firma', name: 'receiverFirmName', order: 0, isVisible: true },
            { title: 'Gönderici Firma', name: 'senderFirmName', order: 0, isVisible: true },
            { title: 'Gümrük Firması', name: 'dutyFirmName', order: 0, isVisible: true },
            { title: 'Gümrük Müdürlüğü', name: 'customsDirectorateName', order: 0, isVisible: true },
            { title: 'Çıkış Ülkesi', name: 'exitCountryName', order: 0, isVisible: true },
            { title: 'Depo Giriş Tarihi', name: 'storageEnteranceDateStr', order: 0, isVisible: true },
            // Araçlardan (alt tablo) birleşik kolonlar.
            { title: 'Araç Plaka', name: 'vehiclePlates', order: 0, isVisible: true },
            { title: 'Dorse Plaka', name: 'trailerPlates', order: 0, isVisible: true },
            { title: 'Tedarikçi', name: 'supplierNames', order: 0, isVisible: true },
            { title: 'Beyan Kap', name: 'declarationPotQuantity', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Beyan Ağırlık', name: 'declarationPotWeight', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Toplam Kap', name: 'totalPotQuantity', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Toplam Ağırlık', name: 'totalGrossWeight', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Bekleyen Kap', name: 'waitingTotalPotQuantity', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Bekleyen Ağırlık', name: 'waitingTotalGrossWeight', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Stok Kap', name: 'stockTotalPotQuantity', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Stok Ağırlık', name: 'stockTotalGrossWeight', order: 0, isVisible: true, className: 'custom-text-right' },
            // Eski arama kutusunun aradığı alanlar: varsayılan gizli, kolon seçiciden açılır.
            { title: 'Serbest Depo Ref No', name: 'freeStorageRefNo', order: 0, isVisible: false },
            { title: 'Konteyner No', name: 'containerNos', order: 0, isVisible: false },
            { title: 'Taşıma Belge No', name: 'transportDocumentNos', order: 0, isVisible: false },
            { title: 'Kamyon Rapor No', name: 'truckReportNos', order: 0, isVisible: false },
            { title: 'Özet Beyan No', name: 'summaryDeclarationNos', order: 0, isVisible: false },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteAntrepoIn = async () => {
        try {
            dispatch(storeActivityIndicator(true))

            for (var i = 0; i < data.items.filter(x => x.isSelected).length; i++) {
                var response2: GetAntrepoOutListByAntrepoInIdResponse = await AntrepoOutService.getAntrepoOutListByAntrepoInId(data.items.filter(x => x.isSelected)[i].antrepoInId);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    dispatch(storeActivityIndicator(false))
                    return;
                }

                if (response2.data.length > 0) {
                    toast.error(data.items.filter(x => x.isSelected)[i].ledgerNo + ' defter numaralı giriş kayıdına ait çıkış kayıdı olduğu için silme yapılamaz!')
                    dispatch(storeActivityIndicator(false))
                    return;
                }

                if (data.items.filter(x => x.isSelected)[i].antrepoInVehicles.length > 0 && Helpers.isEmpty(data.items.filter(x => x.isSelected)[i].transferAntrepoOutId)) {
                    toast.error(data.items.filter(x => x.isSelected)[i].ledgerNo + ' defter numaralı giriş kayıdında araç bilgisi olduğu için silme yapılamaz!')
                    dispatch(storeActivityIndicator(false))
                    return;
                }
            }

            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.antrepoInId);

            var response: DeleteAntrepoInResponse = await AntrepoInService.deleteAntrepoIn(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateAntrepoIn = async (_id: string | undefined = undefined) => {
        navigate('/antrepoin/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].antrepoInId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetAntrepoInListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            dispatch(storeActivityIndicator(true));

            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            var response: GetAntrepoInListPagingAndFilterResponse = await AntrepoInService.getAntrepoInListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.antrepoInId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportAntrepoInListResponse = await AntrepoInService.exportAntrepoInList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.antrepoInId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Toplam/bekleyen/stok kap ve ağırlıklar
    // bellekte hesaplandığı, beyanname durumu ile satış şekli de bellekte üretilen metin
    // olduğu için sıralanabilir değildir.
    const sortableColumns = [
        'ledgerNo', 'antrepoDeclarationNo', 'antrepoDeclarationDateStr',
        'receiverFirmName', 'senderFirmName', 'dutyFirmName',
        'customsDirectorateName', 'exitCountryName', 'storageEnteranceDateStr',
        'declarationPotQuantity', 'declarationPotWeight',
        'createdUser', 'updatedUser'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (AntrepoInManager.ApplyColumnFilters) aynı. Araç / dorse / tedarikçi / giriş tarihi ve
    // gizli numara kolonları araçlar alt tablosundan: kayıtta en az bir araç uyuyorsa gelir.
    // Toplam / bekleyen / stok kolonları bellekte hesaplandığı için filtresiz.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        ledgerNo: { type: 'text' },
        antrepoDeclarationNo: { type: 'text' },
        antrepoDeclarationDateStr: { type: 'date' },
        declarationStatusName: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve(DECLARATION_STATUS_OPTIONS), renderOption: (label) => <StatusBadge text={label} /> },
        // Listede "INCOTERM kodu - adı" olarak görünür.
        saleTypeName: { type: 'select', loadOptions: () => loadList(ConstantService.getConstantList('INCOTERM'), 'constantId', x => (x.additionalValue1 ?? '') + ' - ' + x.value) },
        antrepoEnteranceDatesStr: { type: 'date' },
        receiverFirmName: { type: 'select', loadOptions: () => loadCompanies({ isReceiverFirm: true }, { isCustomer: true }) },
        senderFirmName: { type: 'select', loadOptions: () => loadCompanies({ isSenderFirm: true }, { isCustomer: true }) },
        dutyFirmName: { type: 'select', loadOptions: () => loadCompanies({ isDutyFirm: true }, { isCustomer: true }) },
        customsDirectorateName: { type: 'select', loadOptions: () => loadConstants('ANTREPO') },
        exitCountryName: { type: 'select', loadOptions: () => loadList(CountryService.getCountryList(), 'countryId', x => x.name) },
        storageEnteranceDateStr: { type: 'date' },
        vehiclePlates: { type: 'text' },
        trailerPlates: { type: 'text' },
        supplierNames: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isSupplier: true }), 'companyId', x => x.name) },
        declarationPotQuantity: { type: 'number' },
        declarationPotWeight: { type: 'number' },
        freeStorageRefNo: { type: 'text' },
        containerNos: { type: 'text' },
        transportDocumentNos: { type: 'text' },
        truckReportNos: { type: 'text' },
        summaryDeclarationNos: { type: 'text' },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetAntrepoInListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "ledgerNo") {
            return (
                <td className={className} onClick={() => setItemSelected(item.antrepoInId)} onDoubleClick={() => updateAntrepoIn(item.antrepoInId)}><a onClick={() => window.open(window.location.href + "add?id=" + item.antrepoInId, "_blank")} href='javascript:;'>{item.ledgerNo}</a></td>
            )
        }
        else if (column == "declarationStatusName") {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.antrepoInId)} onDoubleClick={!item.companyId ? undefined : () => updateAntrepoIn(item.antrepoInId)}><StatusBadge text={item2[column]} /></td>;
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.antrepoInId)} onDoubleClick={!item.companyId ? undefined : () => updateAntrepoIn(item.antrepoInId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.antrepoInId)} onDoubleClick={!item.companyId ? undefined : () => updateAntrepoIn(item.antrepoInId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (['declarationPotQuantity', 'declarationPotWeight', 'totalPotQuantity', 'totalGrossWeight', 'waitingTotalPotQuantity', 'waitingTotalGrossWeight', 'stockTotalPotQuantity', 'stockTotalGrossWeight'].includes(column)) {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.antrepoInId)} onDoubleClick={!item.companyId ? undefined : () => updateAntrepoIn(item.antrepoInId)}>{Helpers.correctPrice(item2[column], 0)}</td>;
            // return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.antrepoInId)} onDoubleClick={!item.companyId ? undefined : () => updateAntrepoIn(item.antrepoInId)}>{Helpers.correctPrice(item2[column], 2)}</td>;
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.antrepoInId)} onDoubleClick={!item.companyId ? undefined : () => updateAntrepoIn(item.antrepoInId)}>{item2[column]}</td>;
        }
    }

    // Dip toplam: görüntülenen sayfadaki kayıtların toplamı. Kap/ağırlık kolonları satır
    // hücresiyle aynı biçimde (ondalıksız) yazılır; diğer kolonlar boş bırakılır.
    const getTotalValue = (columnName: string, columnIndex: number, className: string | undefined) => {
        const totals: any = data.totals;

        if (columnIndex == 0) {
            return <td className={className}>Toplam</td>;
        }

        if (['declarationPotQuantity', 'declarationPotWeight', 'totalPotQuantity', 'totalGrossWeight', 'waitingTotalPotQuantity', 'waitingTotalGrossWeight', 'stockTotalPotQuantity', 'stockTotalGrossWeight'].includes(columnName)) {
            return <td className={className}>{Helpers.correctPrice(totals ? totals[columnName] : 0, 0)}</td>;
        }

        return <td className={className}></td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <AntrepoInListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    items={data.items}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteAntrepoIn}
                    updateFunction={updateAntrepoIn}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table ebbe-table-fill'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                    <input onChange={() => setItemSelected(item.antrepoInId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                    {
                                        /* Az kayıt geldiğinde kalan boşluğu doldurur; dip toplam satırı
                                           tablonun altına iner, çerçeve hep aynı yerde kalır. */
                                        data.items.length > 0 && (
                                            <tr className="ebbe-table-filler">
                                                <td colSpan={99}></td>
                                            </tr>
                                        )
                                    }
                                </tbody>

                                {
                                    data.items.length > 0 && (
                                        <tfoot>
                                            <tr>
                                                <td style={{ width: 1 }}></td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getTotalValue(column.name, columnIndex, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        </tfoot>
                                    )
                                }
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default AntrepoInList;